/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

/**
 * The useReduxState is a hook responsible for store some state
 * into store in redux-store and fetching the same state from store.
 * This can be used as in the format of useState hook.
 *
 * ```typescript
 *
 *  import {useReduxState} from '@ion/applications/src/hooks/';
 *
 *  const [mapView, setMapView] = useReduxState('SET_MAP_VIEW', ({store}) => store.mapView);
 *
 * ```
 */
export const useReduxState = (type: string, selector: (state: unknown) => unknown) => {
  const dispatch = useDispatch();
  const state    = useSelector(selector);

  const setState = useCallback((state) => {
    dispatch({type, state});
  }, []);

  return [state, setState];
};

export default useReduxState;
